import React, { useState,useMemo, forwardRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  InputGroup
} from 'react-bootstrap';
import { get_all_cards } from '../../../../utils/talent_services';


const Type_link = (({ user_id, permission, typesOptions, onSet}) => {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');

   
  

    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = typesOptions;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
      
  
      return result;
    }, [searchTerm,  typesOptions]);


    const add_linked_strategy = (id, title) => {
      onSet(id, title);
    };

    
   

    // ---------- UI ----------
    return (
      <div className="container py-4">

        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="Buscar tipo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </InputGroup>
        </div>

        {/* Tabla */}
        <div style={{ height: '400px', overflowY: 'auto' }}> {/* Altura fija y scroll */}
          {/* Añade la clase text-start aquí */}
          <Table hover responsive className="align-middle text-start">
            <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
              <tr >
                  <th role="button">
                    Tipología 
                  </th>
                   <th role="button">
                    Categoria 
                  </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} onClick={() => add_linked_strategy(row.id, row.name)} >
                  <td>{row.name}</td>
                  <td>{row.category}</td>
                </tr>

              ))}
              {rows.length === 0 && (
                <tr>
                  {/* También puedes añadir text-start aquí si quieres asegurar la alineación para el mensaje "No results" */}
                  <td colSpan="10" className="text-center py-4 text-start">
                    No results
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    );
});

export default Type_link;
